import { render, staticRenderFns } from "./TravellerList.vue?vue&type=template&id=61428e4c&"
import script from "./TravellerList.vue?vue&type=script&lang=js&"
export * from "./TravellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports